import { z } from "zod";
import { BaseTemplateSchema } from "../types/schema";
import { PRESETS, CROSSFADE_DURATION_FRAMES } from "../constants";

export { PRESETS, CROSSFADE_DURATION_FRAMES };


export const defaultVisualizer = {
	color: "#ffffff",
	barWidth: 10,
	gap: 4,
	maxHeight: 48,
	position: "bottom-center" as const,
	barsToDisplay: 32,
};

export const VisualizerConfigSchema = z.object({
	color: z.string().default(defaultVisualizer.color),
	barWidth: z.number().default(defaultVisualizer.barWidth),
	gap: z.number().default(defaultVisualizer.gap),
	maxHeight: z.number().default(defaultVisualizer.maxHeight),
	position: z
		.enum(["bottom-left", "bottom-center", "bottom-right"])
		.default(defaultVisualizer.position),
	barsToDisplay: z.number().default(defaultVisualizer.barsToDisplay),
});

export const AudioVisualizerSchema = BaseTemplateSchema.extend({
	seed: z.number().default(42),
	visualizer: VisualizerConfigSchema.default(defaultVisualizer),
	isTest: z.boolean().optional(),
	withTitle: z.boolean().default(true),
});

export type AudioVisualizerProps = z.infer<typeof AudioVisualizerSchema>;

export const VISUALIZER_LAYOUT = {
	PADDING_BOTTOM_WITH_TITLE: 120,
	PADDING_BOTTOM_NO_TITLE: 70,
	TEXT_BOTTOM_OFFSET: 70,
	MARGIN_SIDE: 100,
	SAMPLES_TO_FETCH: 4096,
	MIN_BIN_INDEX: 2,
	MAX_BIN_INDEX: 256,
} as const;

export const defaultAudioVisualizerProps: AudioVisualizerProps = {
	seed: 42,
	isTest: false,
	withTitle: true,
	title: "AUDIO REACTIVE",
	backgroundUrl:
		"https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1920",
	audioTracks: [
		{
			durationInSeconds: 17,
			title: "Sci-Fi Drama",
			url: "https://cdn.mixetape.com/sample.mp3",
		},
		{
			durationInSeconds: 17,
			title: "Industrial Hum",
			url: "https://cdn.mixetape.com/sample.mp3",
		},
	],
	visualizer: defaultVisualizer,
};
